export default __webpack_public_path__ + "static/media/FaroDelanteroIzquierdo.cfa19f95.jpg";